var map = {
	"./CUIABA/data.json": "kmPt",
	"./DOE-AL/data.json": "qJ/2",
	"./PMVG/data.json": "D7CY",
	"./TCE-AL/data.json": "gX4K"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Z2pz";


//////////////////
// WEBPACK FOOTER
// ./src/client ^\.\/.*\/data\.json$
// module id = Z2pz
// module chunks = 1